import axios from "axios";
import React, { useState } from "react";
import { API } from "../configs/urlConfig";
import Utils from "../utils";
import CustomerInvestmentModal from "./CustomerInvestmentModal";
import EditInvestmentModal from "./EditInvestmentModal";
import { useNavigate } from "react-router-dom";

const Musterije = ({ data, setData, date, fetchData, user, allDate }) => {
  console.log("Musterijeeee", allDate);
  const navigate = useNavigate();
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [paymentDescription, setPaymentDescription] = useState("");
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [customer, setCustomer] = useState({ name: "", id: "" });
  const [investment, setInvestment] = useState(null);
  const getStatusBadge = (
    status,
    schedule,
    itemId,
    customer_id,
    investment_id,
  ) => {
    let statusColor = "bg-warning";
    let statusText = "⏳ U toku";

    if (status === "PAID") {
      statusColor = "bg-success";
      statusText = "✓ Plaćeno";
    } else if (status === "OVERDUE") {
      statusColor = "bg-danger";
      statusText = "⚠ Prekoračeno";
    }

    return (
      <button
        className={`badge ${statusColor}`}
        onClick={() =>
          openPaymentModal(schedule, itemId, customer_id, investment_id)
        }
        style={{
          border: "none",
          cursor: "pointer",
          padding: "0.5em 0.75em",
        }}
      >
        {statusText}
      </button>
    );
  };

  const openPaymentModal = (schedule, itemId, customer_id, investment_id) => {
    setSelectedSchedule({ ...schedule, itemId, customer_id, investment_id });
    setPaymentDescription("");
    setShowPaymentModal(true);
  };

  const closePaymentModal = () => {
    setShowPaymentModal(false);
    setSelectedSchedule(null);
    setPaymentDescription("");
  };

  const handlePayment = async (action = "add") => {
    if (!selectedSchedule) return;

    try {
      setPaymentLoading(true);
      console.log("selectedSchedule", selectedSchedule);
      // Šaljem zahtev na backend
      const paymentData = {
        action: action,
        customer_id: selectedSchedule.customer_id,
        investment_id: selectedSchedule.investment_id,
        item_id: selectedSchedule.itemId,
        payout_id: selectedSchedule.payout_id,
        installment: selectedSchedule.installment,
        expected_date: selectedSchedule.expected_date,
        amount: selectedSchedule.amount,
        description: paymentDescription,
      };

      const response = await axios.post(
        `${API}/payment/`,
        paymentData,
        Utils.getUserToken(),
      );

      console.log("Plaćanje izvršeno:", response.data);
      // alert("Plaćanje je uspešno izvršeno!");
      closePaymentModal();

      // Osvežavamo podatke
      if (date) {
        const refreshResponse = await axios.get(
          `${API}/bydate/?date=${date}`,
          Utils.getUserToken(),
        );
        setData(refreshResponse.data);
      } else {
        const refreshResponse = await axios.get(
          `${API}/get-customers/`,
          Utils.getUserToken(),
        );
        setData(refreshResponse.data);
      }
    } catch (err) {
      console.error(err);
      alert(
        "Greška pri izvršavanju plaćanja: " +
          (err.response?.data?.message || err.message),
      );
    } finally {
      setPaymentLoading(false);
    }
  };
  const handleNastavi = async (id) => {
    try {
      setPaymentLoading(true);
      console.log("handleNastavi", id);
      // Šaljem zahtev na backend
      const paymentData = {
        investment_id: id,
      };

      const response = await axios.post(
        `${API}/customer_investment_add_period/`,
        paymentData,
        Utils.getUserToken(),
      );

      console.log("Plaćanje izvršeno:", response.data);
      // alert("Plaćanje je uspešno izvršeno!");

      // Osvežavamo podatke
      if (date) {
        const refreshResponse = await axios.get(
          `${API}/bydate/?date=${date}`,
          Utils.getUserToken(),
        );
        setData(refreshResponse.data);
      } else {
        const refreshResponse = await axios.get(
          `${API}/get-customers/`,
          Utils.getUserToken(),
        );
        setData(refreshResponse.data);
      }
    } catch (err) {
      console.error(err);
      alert(
        "Greška pri izvršavanju plaćanja: " +
          (err.response?.data?.message || err.message),
      );
    } finally {
      setPaymentLoading(false);
    }
  };
  return (
    <div style={{ fontSize: "13px" }}>
      {data.payouts.length > 0 ? (
        <div className={`row ${allDate ? "mb-4" : ""}`}>
          {data.payouts.map((payout) => (
            <div key={`${payout.customer_id}`} className={`col-md-6 mb-4`}>
              <div className="card shadow-sm">
                <div
                  className="text-white d-flex justify-content-between align-items-center"
                  style={{
                    padding: "0.25rem",
                    background:
                      "linear-gradient(135deg, rgba(23, 32, 51, 0.94), rgba(17, 94, 89, 0.94))",
                  }}
                >
                  <div
                    className="d-flex justify-flex-start"
                    style={{ width: "25%" }}
                    onClick={() => {
                      setCustomer({
                        name: payout.customer_name,
                        id: payout.customer_id,
                      });
                      setShowModal(true);
                    }}
                  >
                    <small>{payout.customer_name}</small>
                  </div>
                  <div className="d-flex justify-flex-start w-25">
                    <small>
                      {Utils.formatirajBroj(payout.total_invested_amount)}
                    </small>
                  </div>
                  <div className="d-flex justify-flex-start w-25">
                    <small>{Utils.formatirajBroj(payout.total_payout)}</small>
                  </div>
                  <div className="d-flex justify-flex-start w-25">
                    <small>{Utils.formatirajBroj(payout.total_paid)}</small>
                  </div>
                  {!user && (
                    <div
                      onClick={() => navigate(`/user/${payout.customer_id}`)}
                      style={{
                        width: "20px",
                        height: "12px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "10px",
                          height: "10px",
                          marginRight: "4px",
                          borderTop: "3px solid white",
                          borderRight: "3px solid white",
                          // transform: "rotate(0deg)",
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="card-body p-0 h-100">
                  {payout.items && payout.items.length > 0 ? (
                    <div
                      className="accordion"
                      id={`accordion-${payout.customer_id}`}
                    >
                      {payout.items.map((item, itemIndex) => {
                        const ukupno_rata = item.payout_schedule.length * 12;
                        return (
                          <div key={item.id} className="accordion-item">
                            <button
                              className="accordion-button collapsed p-1"
                              type="button"
                              style={{
                                background:
                                  "linear-gradient(135deg, rgba(15, 118, 110, 0.08), rgba(245, 158, 11, 0.08))",
                              }}
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapse-${item.id}`}
                            >
                              <div
                                style={{ fontSize: "12px" }}
                                className="d-flex justify-content-between align-items-center w-100"
                              >
                                <div className="d-flex justify-flex-start w-25">
                                  <small
                                    style={{ zIndex: 9 }}
                                    onClick={() => {
                                      setInvestment({
                                        customer_name: payout.customer_name,
                                        customer_id: payout.customer_id,
                                        investment_id: item.investment_id,
                                        deposit_date: item.deposit_date,
                                        invested_date: item.invested_date,
                                        invested_amount: item.invested_amount,
                                        payout: item.payout,
                                      });
                                      setShowEditModal(true);
                                    }}
                                  >
                                    {item.invested_date}
                                  </small>
                                </div>
                                <div className="d-flex justify-flex-start w-25">
                                  <small>
                                    {Utils.formatirajBroj(item.invested_amount)}
                                  </small>
                                </div>

                                <div className="d-flex justify-flex-start w-25">
                                  <small>{item.payout}</small>
                                </div>

                                <div className="d-flex justify-flex-start w-25">
                                  <small>
                                    {Utils.formatirajBroj(item.total_paid)}
                                  </small>
                                </div>
                                <div>
                                  <small
                                    style={{ fontSize: "9px" }}
                                  >{`${ukupno_rata > 1 ? `${item.total_placeno}/${ukupno_rata}` : ""}`}</small>
                                </div>
                              </div>
                            </button>

                            <div
                              id={`collapse-${item.id}`}
                              className="accordion-collapse collapse"
                              data-bs-parent={`#accordion-${payout.customer_id}`}
                            >
                              {item.payout_schedule.map((period, index) => {
                                return (
                                  <div
                                    className="accordion-body p-0"
                                    key={period.period}
                                  >
                                    <div className="table-responsive">
                                      <table className="table table-sm table-hover mb-0">
                                        {index === 0 && (
                                          <thead
                                            className="table-light"
                                            style={{ fontSize: "13px" }}
                                          >
                                            <tr>
                                              <th>Rata</th>
                                              <th>Rok</th>
                                              <th>Iznos</th>
                                              <th>Status</th>
                                            </tr>
                                          </thead>
                                        )}

                                        <tbody>
                                          {period.schedule.map((schedule) => {
                                            return (
                                              <tr
                                                key={schedule.installment}
                                                className={
                                                  schedule.paid
                                                    ? "table-success"
                                                    : schedule.status ===
                                                        "OVERDUE"
                                                      ? "table-danger"
                                                      : ""
                                                }
                                              >
                                                <td>
                                                  <small className="text-muted">
                                                    #{schedule.installment}
                                                  </small>
                                                </td>
                                                <td>
                                                  <small>
                                                    {
                                                      schedule.expected_date_formated
                                                    }
                                                  </small>
                                                </td>
                                                <td>
                                                  {schedule.status ===
                                                    "PAID" && (
                                                    <strong>
                                                      {schedule.amount}
                                                    </strong>
                                                  )}
                                                </td>
                                                <td>
                                                  {getStatusBadge(
                                                    schedule.status,
                                                    schedule,
                                                    item.id,
                                                    payout.customer_id,
                                                    item.investment_id,
                                                  )}
                                                </td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                    <div
                                      className="card-footer bg-light"
                                      style={{ borderBottom: "2px solid #000" }}
                                    >
                                      <div style={{ marginLeft: "50px" }}>
                                        <span className="me-3">
                                          {period.period}{" "}
                                        </span>
                                        <strong style={{ marginRight: "40px" }}>
                                          Ukupno:
                                        </strong>
                                        <strong>
                                          {Utils.formatirajBroj(
                                            period?.total_period,
                                          )}
                                        </strong>
                                        {period.period ===
                                          item.payout_schedule.length &&
                                          period.placeno === 12 && (
                                            <button
                                              className={`ms-3 badge bg-success`}
                                              onClick={() =>
                                                handleNastavi(
                                                  item.investment_id,
                                                )
                                              }
                                              style={{
                                                border: "none",
                                                cursor: "pointer",
                                                padding: "0.5em 0.75em",
                                              }}
                                            >
                                              Nastavi
                                            </button>
                                          )}
                                      </div>

                                      {/* {ukupno_rata === placeno && (
                                                                    <span className="badge bg-success" onClick={() => console.log()}>SVE PLAĆENO</span>
                                                                )}
                                                                <small className="text-muted">
                                                                    Ukupno rata: {ukupno_rata} |
                                                                    Plaćeno: {placeno}
                                                                </small> */}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <p className="p-3 text-muted">Nema stavki za ovog kupca</p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="alert alert-info" role="alert">
          Nema podataka za ovaj datum
        </div>
      )}

      {/* Payment Modal */}
      {showPaymentModal && selectedSchedule && (
        <div
          className="modal show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">
                  Potvrdi Plaćanje za {selectedSchedule.expected_date_formated}
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={closePaymentModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="d-flex align-items-center justify-content-center w-100">
                  {/* <div className="d-flex align-items-center mb-3 fs-5">

                                        <p className="text-success  fw-bold mb-0" style={{ fontSize: '35px' }}>{selectedSchedule.amount} €</p>
                                    </div> */}
                  <div className="d-flex align-items-center mb-3 fs-5">
                    <input
                      type="number"
                      className="form-control text-success fw-bold text-center"
                      value={selectedSchedule.amount}
                      onFocus={(e) => e.target.select()}
                      onChange={(e) =>
                        setSelectedSchedule({
                          ...selectedSchedule,
                          amount: e.target.value,
                        })
                      }
                      style={{
                        fontSize: "35px",
                        maxWidth: "200px",
                        borderRadius: "15px",
                      }}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="description" className="form-label">
                    Napomena (opciono):
                  </label>
                  <textarea
                    id="description"
                    className="form-control"
                    rows="3"
                    value={paymentDescription}
                    onChange={(e) => setPaymentDescription(e.target.value)}
                    placeholder="Unesi napomenu ako je potrebna..."
                  ></textarea>
                </div>

                <div className="alert alert-info" role="alert">
                  <small>
                    Klikom na dugme "Uplati" potvrđuješ plaćanje od{" "}
                    <strong>{selectedSchedule.amount} €</strong> za{" "}
                    <strong>{selectedSchedule.expected_date_formated}</strong>
                  </small>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => handlePayment("delete")}
                >
                  Obriši
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closePaymentModal}
                >
                  Otkaži
                </button>
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => handlePayment("add")}
                  disabled={paymentLoading}
                >
                  {paymentLoading ? "Učitavanje..." : "✓ Uplati"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {showModal && (
        <CustomerInvestmentModal
          onClose={() => {
            setCustomer({ name: "", id: "" });
            setShowModal(false);
          }}
          customer={customer}
          onSave={(customer) => fetchData(customer)}
        />
      )}
      {showEditModal && (
        <EditInvestmentModal
          onClose={() => {
            setInvestment(null);
            setShowEditModal(false);
          }}
          investment={investment}
          onSave={(customer) => fetchData(customer)}
        />
      )}
    </div>
  );
};

export default Musterije;
